import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "ui/components/form";

import ButtonWithLoading from "@/components/button-with-loading";
import { Form } from "react-crud-form";
import { Textarea } from "ui/components/textarea";
import { unlockTimesheetSchema } from "./schema"; // Adjust the import path as needed
import { useForm } from "react-hook-form";
import { useUnlockTimesheet } from "components/timesheet/unlock/useUnlockTimesheet";
import { zodResolver } from "@hookform/resolvers/zod";

const TimesheetUnlockForm = ({ date, onOpenChange }) => {
  const { syncTimesheetUnlock } = useUnlockTimesheet();

  const form = useForm({
    resolver: zodResolver(unlockTimesheetSchema),
    defaultValues: {
      date: date,
      justification: "",
    },
  });

  const handleSubmit = async (context) => {
    const { date, justification } = context.values;
    await syncTimesheetUnlock(date, justification);
  };

  const handleClose = () => {
    form.reset();
    onOpenChange(false);
  };
  return (
    <Form
      form={form}
      schema={unlockTimesheetSchema}
      itemId={"+"}
      create={handleSubmit}
      className="h-full w-full"
    >
      {({ isCreating, createItem }) => (
        <div className="flex flex-col">
          <FormField
            control={form.control}
            name="justification"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <Textarea
                    placeholder="Justification"
                    className="h-32"
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <ButtonWithLoading
            variant="default"
            isLoading={isCreating}
            className="mt-4 place-self-end"
            onClick={() => {
              createItem().then(handleClose);
            }}
          >
            Yes, Unlock{" "}
          </ButtonWithLoading>
        </div>
      )}
    </Form>
  );
};

export default TimesheetUnlockForm;
